module.exports = __webpack_public_path__ + "static/img/icon_content.7252ed1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_content.png
// module id = 334
// module chunks = 7